import React from "react";
import { useReveal } from "../hooks/useReveal";
import Countdown from "./Countdown";

export default function FinalCTA({ onNotify }) {
  const ref = useReveal();
  return (
    <section
      id="final-cta"
      data-testid="final-cta-section"
      className="section relative overflow-hidden"
    >
      <div className="absolute inset-0 -z-0 pointer-events-none">
        <div
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[140%] aspect-square rounded-full blur-3xl opacity-40"
          style={{
            background:
              "radial-gradient(circle at center, rgba(31,179,255,0.22), transparent 60%)",
          }}
        />
      </div>

      <div
        ref={ref}
        className="reveal container-x relative z-10 max-w-4xl text-center mx-auto"
      >
        <span className="font-mono text-sm uppercase tracking-[0.3em] text-white/55">
          / 10 — The Invitation
        </span>
        <h2
          className="kinetic mt-6"
          style={{ fontSize: "clamp(2.8rem, 9vw, 8rem)", lineHeight: 0.9 }}
        >
          <span className="block gradient-text">CAN A SIMPLE RITUAL</span>
          <span className="block outline-text-blue">CHANGE YOUR STATE?</span>
        </h2>
        <p className="mt-10 text-lg lg:text-xl text-white/65 leading-relaxed max-w-2xl mx-auto">
          Apply to join the first 100 participants helping shape the future of
          intentional performance.
        </p>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-4">
          <button
            data-testid="final-cta-apply"
            data-magnet
            onClick={onNotify}
            className="btn-primary"
          >
            <span>Apply to the protos 100</span>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path
                d="M5 12h14M13 5l7 7-7 7"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>

        <div className="mt-8 flex justify-center">
          <Countdown testId="final-countdown" label="Applications close in" />
        </div>
      </div>
    </section>
  );
}
